import { useParams } from 'react-router-dom';
import { Box, Stack } from '@mui/material';
import { ProjectStatusEnum, RoleEnum } from '~/api/types';
import { useGetProjectQuery } from '~/api/v2/hooks';
import { AddNewMemberForm, ChangeProjectOwnerForm, ProjectMembersTable } from './components';

export const PROJECT_ADDABLE_ROLES = [RoleEnum.DATA_SCIENTIST, RoleEnum.TECHNICIAN_ANNOTATOR];

const ProjectMembersTab = () => {
  const projectId = +useParams().projectid!;
  const { data: projectData } = useGetProjectQuery({ projectId });

  return (
    <Box p="3rem">
      <ProjectMembersTable />
      {projectData?.status !== ProjectStatusEnum.INACTIVE && (
        <Stack direction="row" spacing={4} mt="2rem" width="100%">
          <AddNewMemberForm />
          <ChangeProjectOwnerForm />
        </Stack>
      )}
    </Box>
  );
};

export default ProjectMembersTab;
